import { ftClockCampaignField } from '../../shared/campaign-clock';
import { itemIdOf } from '../../encounter-map/ft3d/perception';

type Row = Record<string, unknown>;

/** Attendance embeds carry UTC bounds, including the ten-minute ready lead-in. */
export function parseCampaignSessionUtc(raw: unknown): number | null {
    if (typeof raw !== 'string' || !raw.trim()) return null;
    let iso = raw.trim().replace(' ', 'T');
    if (!/Z|[+-]\d\d:\d\d$/.test(iso)) iso += 'Z';
    const time = Date.parse(iso);
    return Number.isFinite(time) ? time : null;
}

export function campaignSessionWindowContains(session: { prompt_start?: unknown; session_end?: unknown }, now: number): boolean {
    const start = parseCampaignSessionUtc(session.prompt_start);
    const end = parseCampaignSessionUtc(session.session_end);
    return start !== null && end !== null && now >= start && now <= end;
}

/** Joining uses the ready window; confirming attendance itself still activates in place. */
export function campaignArrivalDestination(campaign: Row, now: number): { destinationId: string; reason: string } {
    const loaded = itemIdOf(ftClockCampaignField(campaign, 'encounter_loaded'));
    if (Array.isArray(campaign.campaign_sessions)
        && campaign.campaign_sessions.some(session => campaignSessionWindowContains(session as Row, now))) {
        return { destinationId: loaded, reason: loaded ? 'session-loaded-encounter' : 'no-loaded-encounter-stay-put' };
    }
    const camp = itemIdOf(ftClockCampaignField(campaign, 'campaign_campsite_encounter_id'));
    return camp ? { destinationId: camp, reason: 'outside-session-campsite' }
        : { destinationId: loaded, reason: loaded ? 'no-campsite-loaded-fallback' : 'no-campsite-or-loaded-stay-put' };
}
